import { useNavigate } from 'react-router-dom';
import { FaWhatsapp, FaComments } from 'react-icons/fa';

export const Support = () => {
  const navigate = useNavigate();

  const handleChatClick = () => {
    navigate('/app/chat');
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/2347048161101', '_blank');
  };

  return (
    <div className="font-dashboard pt-8 pb-12 px-4 min-h-screen bg-gray-900 text-white">
      <div className="max-w-5xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-10">
          <h1 className="text-4xl font-bold text-white">Need Help? We’re Here for You!</h1>
          <p className="text-lg text-gray-400 mt-2">
            Choose a support option to get assistance or explore helpful resources.
          </p>
        </div>

        {/* Main Support Options */}
        <div className="grid grid-cols-1 md:grid-cols-1 gap-6 mb-12">
          <div
            onClick={handleChatClick}
            className="flex flex-col items-center p-6 bg-gray-800 text-center rounded-lg shadow-lg cursor-pointer transition hover:bg-gray-700"
          >
            <FaComments size={48} className="text-white mb-4" />
            <h3 className="text-xl font-semibold text-white">Live Chat</h3>
            <p className="text-gray-400 mt-2">Get instant help from our support team.</p>
          </div>
          {/* <div
            onClick={handleWhatsAppClick}
            className="flex flex-col items-center p-6 bg-gray-800 text-center rounded-lg shadow-lg cursor-pointer transition hover:bg-gray-700"
          >
            <FaWhatsapp size={48} className="text-green-400 mb-4" />
            <h3 className="text-xl font-semibold text-white">WhatsApp Support</h3>
            <p className="text-gray-400 mt-2">Chat with us on WhatsApp for quick support.</p>
          </div> */}
        </div>

        {/* Additional Resources */}
        {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="p-6 bg-gray-800 text-center rounded-lg shadow-lg hover:bg-gray-700 transition">
            <h3 className="text-lg font-semibold text-white mb-2">FAQs</h3>
            <p className="text-gray-400">
              Find answers to common questions about GCBUYING services.
            </p>
          </div>
          <div className="p-6 bg-gray-800 text-center rounded-lg shadow-lg hover:bg-gray-700 transition">
            <h3 className="text-lg font-semibold text-white mb-2">Payment Issues</h3>
            <p className="text-gray-400">
              Learn how to resolve payment or transaction issues.
            </p>
          </div>
          <div className="p-6 bg-gray-800 text-center rounded-lg shadow-lg hover:bg-gray-700 transition">
            <h3 className="text-lg font-semibold text-white mb-2">Account Support</h3>
            <p className="text-gray-400">
              Get help with your account, login, or profile settings.
            </p>
          </div>
        </div> */}
      </div>
    </div>
  );
};
